import { useTranslation } from "react-i18next";
import type { IncidentStatus } from "@/lib/types";

const STATUS_STYLES: Record<IncidentStatus, string> = {
  DRAFT: "bg-amber-500/20 text-amber-300 border-amber-700/50",
  ACTIVE: "bg-rose-500/20 text-rose-300 border-rose-700/50",
  ACKNOWLEDGED: "bg-blue-500/20 text-blue-300 border-blue-700/50",
  INVESTIGATING: "bg-indigo-500/20 text-indigo-300 border-indigo-700/50",
  RESOLVED: "bg-emerald-500/20 text-emerald-300 border-emerald-700/50",
};

export function StatusBadge({ status }: { status: IncidentStatus }) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`text-[11px] uppercase tracking-wider font-medium px-2 py-0.5 rounded border ${STATUS_STYLES[status]}`}
    >
      {t(`statusBadge.${status}`)}
    </span>
  );
}
